import {
  currentLanguagePrefix,
  localizedPath,
} from "@shared/lib/localized-path";

export { currentLanguagePrefix };

export function localizedPaymentPath(path: string): string {
  return localizedPath(path);
}

export function createCheckoutAttemptId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
